import styled, { css } from 'styled-components/macro'
import { Button } from '../../commons/Button'
import Icon from '../../commons/Icon'
import Container from '../../components/Container'

export const LoginIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.mono.blackDark};
`

export const Login = styled.div`
  background-position: 20rem;
  background-color: ${({ theme }) => theme.colors.primary.default};
  height: 100vh;

  @media ${({ theme }) => theme.screens.md} {
    background-image: unset;
    min-height: 100vh;
  }
`

export const LoginImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ backgroundImage }) => backgroundImage?.includes('assets') ? '100vh' : '90%'};
  color: ${({ theme }) => theme.colors.mono.blackDark};
  width: 100%;
  max-width: 100%;

  @media ${({ theme }) => theme.screens.md} {
    background-image: unset;
    min-height: 0%;
    width: 0%;
  }
`

export const LoginImage = styled.img`
  max-width: 60%;

  @media ${({ theme }) => theme.screens.md} {
    background-image: unset;
    min-height: 0%;
    width: 0%;
  }
`

export const LoginContainer = styled(Container)`
  height: 100%;
`

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 4rem;
  margin-right: 5%;

  @media ${({ theme }) => theme.screens.md} {
    padding-top: 6rem;
    align-items: unset;
    justify-content: unset;
    gap: 0;
    margin-right: 0;
  }
`

export const LoginInner = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 52rem;
  width: 100%;

  @media ${({ theme }) => theme.screens.md} {
    max-width: unset;
  }
`

export const LoginLogo = styled.img`
  max-width: 100%;
  max-height: 12rem;
`

export const LoginLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
  background: ${({ theme }) => theme.colors.mono.white};
  border-radius: .8rem;
  @media ${({ theme }) => theme.screens.md} {
    width: 16rem;
  }
`

export const LoginTitle = styled.h1`
  max-width: 36.7rem;
  width: 100%;
  margin-top: 3rem;
  font-size: 3.2rem;
  line-height: 3.8rem;
  text-align: center;
  letter-spacing: -0.1rem;
  color: ${({ theme }) => theme.colors.primary.fontColor != '#434647' ? theme.colors.primary.fontColor : theme.colors.mono.blackDark};

  @media ${({ theme }) => theme.screens.lg} {
    font-size: 2.4rem;
    line-height: 2.8rem;
  }
`

export const LoginText = styled.p`
  margin-top: 1.5rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: ${({ theme }) => theme.colors.primary.fontColor != '#434647' ? theme.colors.primary.fontColor : theme.colors.mono.blackDark};
`

export const LoginDisabledText = styled.h3`
  margin-top: 1.5rem;
  color: ${({ theme }) => theme.colors.mono.greyLight};
`

export const LoginBox = styled.div`
  width: 100%;
  margin-top: 3rem;
  padding: 6rem;
  background: ${({ theme }) => theme.colors.mono.white};
  border-radius: .8rem;

  @media ${({ theme }) => theme.screens.lg} {
    padding: 3rem;
  }
`

export const LoginBoxTitle = styled.h3`
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.2rem;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.colors.mono.blackDark};
`

export const LoginBoxText = styled.p`
  margin-bottom: 3rem;
  font-size: 1.3rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
`

export const LoginPasswordLink = styled.button`
  display: inline-flex;
  align-items: center;
  margin-top: 3rem;
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.primary.fontColor != '#434647' ? theme.colors.primary.fontColor : theme.colors.mono.greyLight};

  &:hover {
    color: ${({ theme }) => theme.colors.mono.greyLight};
  }

  ${LoginIcon} {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 2rem;
    transform: rotate(180deg);
  }
`

export const HomeField = styled.div`
  position: relative;
  margin-bottom: 3rem;
`

export const HomeFieldLabel = styled.span`
  position: absolute;
  left: 0;
  bottom: 2rem;
  transition: all .2s ease;
  display: block;
  font-size: 1.3rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.blackDark};
  pointer-events: none;
`

export const HomeFieldInput = styled.input`
  width: 100%;
  padding: 2.9rem 0 1.4rem;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mono.blackDark};

  &:not(:placeholder-shown) + ${HomeFieldLabel},
  &:focus + ${HomeFieldLabel} {
    color: ${({ theme }) => theme.colors.mono.greyDarker};
    bottom: 4.6rem;
  }

  &:focus {
    outline: 0;
  }
`

export const LoginFieldInputPasswordButton = styled.button`${({ isActive }) => css`
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.dark};
  }

  ${isActive && css`
    color: ${({ theme }) => theme.colors.mono.greyDark};
  `}
`}`

export const HomeFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const HomeFieldButton = styled.button`
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: ${({ theme }) => theme.colors.mono.blackDark};

  &:hover {
    color: ${({ theme }) => theme.colors.mono.black};
  }
`

export const LoginButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  padding: 0;
  height: 5rem;
  color: ${({ theme }) => theme.colors.mono.greyLight};
  background-color: ${({ theme }) => theme.colors.blue.default};

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue.dark};
  }

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 .4rem ${({ theme }) => theme.colors.blue.light};
  }

  &:active {
    background: ${({ theme }) => theme.colors.blue.default};
    box-shadow: 0 0 0 .4rem ${({ theme }) => theme.colors.blue.light};
  }
`

export const SignUpText = styled.p`
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  margin-top: 3rem;
  display: flex;
  justify-content: center;
`
export const SignUpLink = styled.a`
  color: ${({ theme }) => theme.colors.mono.blackDark};
  margin-left: 0.5rem;
  cursor: pointer;
`
